





















































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { ICreateContest } from "../types";
import createContestService from '../services/ContestService';

import { Getter } from 'vuex-class'
import { USER_ID } from "../../auth/store/constants";

@Component({
    components: {
    },
})
export default class CreateContest extends Vue {

    @Getter(USER_ID) userId!: string;

    private contest: ICreateContest = {
        title: '',
        competition: "0",
        season: '',
        rounds: ['0', '0'],
        minimumPlayers: 2,
        maximumPlayers: 100,
        maximumEntriesPerPlayer: 2,
        password: '',
        moneyAmount: 0,
        budgetAmount: 0,
        owner: '',
        private: false,
    };

    private errors: string[] = [];

    private competitions = [];
    private rounds = [];

    @Watch('contest.competition')
    async onCompetitionChanged() {
        const c: any = this.competitions.find(x => x['@id'] === this.contest.competition);
        this.contest.season = c.currentSeason['@id'];
        this.rounds = c.currentSeason.rounds.filter((r: any) => r.status === 1).sort((a: any, b: any) => a.name - b.name);
    }

    async mounted() {
        this.competitions = await createContestService.fetchCompetitions();
        this.contest.owner = this.userId;
    }

    private checkForm() {
        if (
            this.contest.title &&
            this.contest.competition &&
            this.contest.rounds &&
            this.contest.minimumPlayers &&
            this.contest.maximumEntriesPerPlayer &&
            // this.contest.moneyAmount &&
            this.contest.budgetAmount
        ) {
            return true;
        }

        this.errors = [];

        if (!this.contest.title) {
            this.errors.push('El titulo es obligatorio.');
        }

        if (this.contest.competition === "0") {
            this.errors.push('Debes seleccionar una competición.');
        }

        if (this.contest.rounds[0] === "0") {
            this.errors.push('Debes seleccionar una jornada inicial.');
        }

        if (this.contest.rounds[1] === "0") {
            this.errors.push('Debes seleccionar una jornada final.');
        }


        if (!this.contest.minimumPlayers || this.contest.minimumPlayers <= 0) {
            this.errors.push('Debes seleccionar el minimo de participantes');
        }

        if (!this.contest.maximumEntriesPerPlayer) {
            this.errors.push('Debes seleccionar las participaciones máximas por usuario.');
        }

        // if (!this.contest.moneyAmount) {
        //     this.errors.push('Debes fijar un precio para acceder al torneo.');
        // }

        if (!this.contest.budgetAmount) {
            this.errors.push('Debes fijar un presupuesto para fichar jugadores.');
        }

    }

    async submit() {
        const formValid = this.checkForm();

        if (!formValid) {
            this.errors.forEach((error: string) => {
                (this as any).$notify({
                    group: 'errors',
                    title: 'Error',
                    text: error,
                    type: 'error',
                });
            });
            return
        }

        try {
            const createdContest = await createContestService.createContest(this.contest);
            this.$router.push('/lobby?joiningContestId=' + createdContest.id)
        } catch (e) {
            console.log(e)
        }
    }

}
